import { cta, shop } from "./shop";

/**
 * Footer copy. See `shop.ts` for what may and may not be changed in a copy pass.
 *
 * Keep FAQ and contact reachable here. Legacy guides have been retired and
 * intentionally have no navigation links.
 */
export const footer = {
  newsletterHeading: "Know when a bike or rebate changes",
  newsletterBody:
    "Get occasional emails about new bikes, Colorado rebate windows, and shop events.",
  newsletterButton: "Get shop updates",

  columns: {
    shop: {
      title: "The shop",
      links: [
        { label: "About us", href: "/about" },
        { label: "Service & repairs", href: "/services" },
        { label: "Hours & directions", href: "/about#visit" },
        { label: "Contact Us", href: "/contact" },
        { label: "FAQ", href: "/faq" },
      ],
    },
    bikes: {
      title: "Bikes",
      links: [
        // No hardcoded count ("All 20 bikes" drifted), no floor claim —
        // the catalog includes models whose availability needs checking.
        { label: "Browse the bikes", href: "/bikes" },
        { label: "Rebates & savings", href: "/savings" },
        { label: "Past models", href: "/bikes#gone" },
      ],
    },
    comeIn: {
      title: "Come in",
      links: [
        { label: "Schedule a test ride", href: "/book" },
        { label: cta.maintenanceLabel, href: cta.maintenanceHref },
        { label: "Hours & test rides", href: "/about#visit" },
        { label: shop.phone, href: shop.phoneHref },
      ],
    },
  },

  whoWeAreTitle: "Family cargo bikes",
  whoWeAreBody:
    "Compare electric cargo bikes for carrying children, weekly errands, and regular trips around Boulder. Bring the family for a free 30-minute test ride, then return for service after the sale.",
  ourShopTitle: "Our shop",
} as const;
